import api from "@/libs/axios";
import * as ep from "../../../guest-pages-management/endpoints";

export default {
  namespaced: true,
  state: {
    meetings: [],
    loading: false,
    pagination: {},
  },
  getters: {
    meetings(state) {
      return state.meetings;
    },
    loading(state) {
      return state.loading;
    },
    pagination(state) {
      return state.pagination;
    },
  },
  mutations: {
    setMeeting(state, payload) {
      state.meetings = payload;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
  },
  actions: {
    async getMeetings(context, payload) {
      context.state.loading = true;
      await api
        .get(ep.MEETING, { params: { page: payload.page } })
        .then((res) => {
          context.commit("setMeeting", res.data.data);
          context.commit("setPagination", res.data.pagination);
          context.state.loading = false;
        });
    },

    async createMeeting(context, payload) {
      context.state.loading = true;
      await api.post(ep.MEETING, payload.fd).then((res) => {
        context.dispatch("getMeetings", { page: payload.page });
      });
    },

    async ubdateMeeting(context, payload) {
      context.state.loading = true;
      await api.post(ep.UP_DATE_MEETING(payload.id), payload.fd).then((res) => {
        context.dispatch("getMeetings", { page: payload.page });
      });
    },

    async deleteMeeting(context, payload) {
      context.state.loading = true;
      await api.delete(ep.UP_DATE_MEETING(payload.id)).then((res) => {
        context.dispatch("getMeetings", { page: payload.page });
      });
    },
  },
};
